import React from "react";
import LoginComponent from "../../component/Login";
const LoginContainer = () => {
  return (
    <div>
      <LoginComponent />
    </div>
  );
};

export default LoginContainer;
